export const version = "sha2/5.2.0";
//# sourceMappingURL=_version.js.map